import { IMAGE_URL } from '../api/routes';

// Version can be "cover/w300"

function cdnUrl(path, version="") {
  if (path && path.length) {
    // Make sure our URLs are neat
    if (path[0] != "/")
      path = `/${path}`
    
    if (version.length && version[0] != "/")
      version = `/${version}`

    return `${IMAGE_URL}${version}${path}`
  }
}

export {
  cdnUrl
}